import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApolloProvider } from '@apollo/client/react';
import { makeClient } from './apollo';
import { App } from './App';
import './index.css';

// The legal pages ship as real bucket objects at dist/<route>/index.html so the
// CDN answers them 200 instead of falling through to not_found_page, which serves
// the shell with a 404 status. The cost is that GCS's MainPageSuffix handling
// 301s /terms to /terms/index.html — a path no route matches, so the router fell
// through to its not-found and the document never rendered.
//
// Normalise the URL back before BrowserRouter reads location. Must run before
// render, and it covers every static route rather than needing a route per
// storage path.
const { pathname, search, hash } = window.location;
const canonicalPath = pathname
  .replace(/\/index\.html$/, '')
  .replace(/(.)\/$/, '$1') || '/';
if (canonicalPath !== pathname) {
  window.history.replaceState(null, '', `${canonicalPath}${search}${hash}`);
}

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <ApolloProvider client={makeClient()}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </StrictMode>,
);
